var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C11.16 36 4 28.84 4 20C4 11.16 11.16 4 20 4C28.84 4 36 11.16 36 20C36 28.83 28.83 36 20 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2902 10.9102H15.7002C13.0602 10.9102 10.9102 13.0602 10.9102 15.7002V24.2902C10.9102 26.9302 13.0602 29.0802 15.7002 29.0802H24.2902C26.9302 29.0802 29.0802 26.9302 29.0802 24.2902V15.7002C29.0802 13.0602 26.9302 10.9102 24.2902 10.9102ZM27.4302 24.2902C27.4302 26.0202 26.0202 27.4302 24.2902 27.4302H15.7002C13.9702 27.4302 12.5602 26.0202 12.5602 24.2902V15.7002C12.5602 13.9702 13.9702 12.5602 15.7002 12.5602H24.2902C26.0202 12.5602 27.4302 13.9702 27.4302 15.7002V24.2902Z",
    fill: "#72BF44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.04C17.27 15.04 15.04 17.26 15.04 20C15.04 22.74 17.26 24.96 20 24.96C22.73 24.96 24.96 22.74 24.96 20C24.96 17.26 22.73 15.04 20 15.04ZM20 23.3C18.18 23.3 16.7 21.82 16.7 20C16.7 18.18 18.18 16.7 20 16.7C21.82 16.7 23.3 18.18 23.3 20C23.3 21.82 21.82 23.3 20 23.3Z",
    fill: "#72BF44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8298 14.1304C24.2598 14.1304 23.7998 14.5904 23.7998 15.1604C23.7998 15.7304 24.2598 16.1904 24.8298 16.1904C25.3998 16.1904 25.8598 15.7304 25.8598 15.1604C25.8698 14.5904 25.3998 14.1304 24.8298 14.1304Z",
    fill: "#72BF44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.316436a764497f902a5120fe25b189da.svg";
export { ForwardRef as ReactComponent };